const CLIENT_ROUTE_PATTERNS = [
  /^\/administrativo\/clientes\/ver\/(\d+)$/,
  /^\/administrativo\/clientes\/(\d+)\/boletas$/,
  /^\/administrativo\/mediciones\/(\d+)$/,
  /^\/administrativo\/cargos-manuales\/(\d+)$/,
];
const ASSISTANT_LAST_ROUTE_KEY = 'agua-andre-assistant-last-admin-route';

export function extractAssistantEntityContext(pathname) {
  const route = String(pathname || '');

  for (const pattern of CLIENT_ROUTE_PATTERNS) {
    const match = route.match(pattern);
    if (match?.[1]) {
      return {
        type: 'cliente',
        id: Number(match[1]),
      };
    }
  }

  return null;
}

export function getAssistantRouteLabel(pathname) {
  const route = String(pathname || '');

  if (route.startsWith('/administrativo/clientes/')) {
    return 'Ficha de cliente';
  }
  if (route.startsWith('/administrativo/mediciones/')) {
    return 'Mediciones del cliente';
  }
  if (route.startsWith('/administrativo/boletas-adeudadas')) {
    return 'Boletas adeudadas';
  }
  if (route.startsWith('/administrativo/control-pagos')) {
    return 'Control de pagos';
  }
  if (route.startsWith('/administrativo/tarifario')) {
    return 'Tarifario';
  }
  if (route.startsWith('/administrativo/planes-pago')) {
    return 'Planes de pago';
  }
  if (route.startsWith('/administrativo/estadisticas')) {
    return 'Estadísticas';
  }

  return 'Panel administrativo';
}

export function rememberAssistantRoute(pathname) {
  const route = String(pathname || '');

  if (!route.startsWith('/administrativo') || route.startsWith('/administrativo/asistente')) {
    return;
  }

  try {
    sessionStorage.setItem(ASSISTANT_LAST_ROUTE_KEY, route);
  } catch (error) {
    // Ignorado: sessionStorage puede no estar disponible.
  }
}

export function resolveAssistantContextPath(pathname) {
  const route = String(pathname || '');

  if (!route.startsWith('/administrativo/asistente')) {
    return route;
  }

  try {
    return sessionStorage.getItem(ASSISTANT_LAST_ROUTE_KEY) || route;
  } catch (error) {
    return route;
  }
}
